export default __webpack_public_path__ + "static/ice_machine_b.9c3ba8050b45faef59183eb746045e32.png";